import RoleAdd from './role_add';
import RoleView from './role_view';
import RoleEdit from './role_edit';
import Roles from './roles';

export {
  RoleAdd,
  RoleView,
  RoleEdit,
  Roles
};
